import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import storeCreator from '../../redux/store';
import {
    BuyPathContext,
    BuyPathContextProp,
    BuyPathContextDefault,
    CMS,
    createLazyProvider,
    PageContextProvider,
} from '../../utils';
import { SearchManagerContext } from '../SearchManager/Context';
import { CarsSearchExtensionProvider } from '../CarsSearchExtension';

CMS.Init({ lng: 'en-ID', brand: 'ED' });
const LazyProvider = createLazyProvider();

const App = ({ children, onSearch, buyPaths }) => {
    const { store, persistor } = storeCreator();

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <LazyProvider>
                    <BuyPathContext.Provider value={buyPaths}>
                        <PageContextProvider>
                            <SearchManagerContext.Provider value={{ onSearch }}>
                                <CarsSearchExtensionProvider>
                                    {children}
                                </CarsSearchExtensionProvider>
                            </SearchManagerContext.Provider>
                        </PageContextProvider>
                    </BuyPathContext.Provider>
                </LazyProvider>
            </PersistGate>
        </Provider>
    );
};

App.propTypes = {
    buyPaths: BuyPathContextProp,
    onSearch: PropTypes.func,
    children: PropTypes.node.isRequired,
};

App.defaultProps = {
    buyPaths: BuyPathContextDefault,
    onSearch: () => {},
};

export default App;
